<template>
  <div class="card my-2">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="cui__utils__heading mb-0">
            <strong>Escalation</strong>
          </div>
          <div class="text-muted">Agent Escalation Across Channels</div>
        </div>
        <div class="col-md-6 text-right">
          <JsonExcel class="" :data="channelsData">
            <v-btn color="blue-grey" outline> Download Data </v-btn>
          </JsonExcel>
        </div>
      </div>
    </div>
    <div class="card-body">
      <v-data-table :items="channelsData" :headers="tableColumns" class="py-2" hide-actions>
        <template v-slot:items="props">
        <td key="name" title="Channel Name" data-index="name">
            <i
            :class="[common.getSocialIcon(getSocialSlug(props.item.name)).class, 'px-1']"
            :style="{
              color: `${common.getSocialIcon(props.item.slug).colorHexa} !important`,
              backgroundColor: 'transparent !important'
            }"/>
            {{ props.item.name }}
        </td>
        <td>
            {{
              props.item.current_sessions ? common.numberWithCommas(props.item.current_sessions) : '-'
            }}
        </td>
        <td>
            {{
              props.item.transferred_to_agent
                ? common.numberWithCommas(props.item.transferred_to_agent)
                : '-'
            }}
        </td>
        <td>
            {{
              props.item.transferred_to_agent_percentage
                ? Math.floor(props.item.transferred_to_agent_percentage)
                : '-'
            }}
            %
        </td>
      </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import common from '@/utils/analytics/common'
import JsonExcel from 'vue-json-excel'
export default {
  name: 'channelsTable',
  components: {
    JsonExcel
  },
  props: {
    channelsData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paymentModel: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      common,
      tableData: []
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          text: 'Channel Name',
          dataIndex: 'name',
          value: 'name'
        },
        {
          text: common.handlePaymentModelName(this.channelsData.payment_model),
          dataIndex: 'current_sessions',
          value: 'current_sessions'
        },
        {
          text: 'Transferred to Agent',
          dataIndex: 'transferred_to_agent',
          value: 'transferred_to_agent'
        },
        {
          text: '% of escalation',
          dataIndex: 'transferred_to_agent_percentage',
          value: 'transferred_to_agent_percentage'
        }
      ]
    }
  },
  methods: {
    getSocialSlug(name) {
      let channel = this.channelsData.find((item) => {
        return item.name === name
      })
      return channel.slug || ''
    }
  }
}
</script>
<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
<style scoped></style>
